export default __webpack_public_path__ + "static/media/building.5dfd115a.png";